import { MfeLoad } from '@carvana/microfrontend';
import { useEffect } from 'react';
import { getMfeCacheBuster } from '@/common/MicroFrontEnds';

export default function useLoadSoftPullMfe() {
  useEffect(() => {
    MfeLoad({
      files: [
        [
          'SoftPullModule',
          [
            {
              component: 'default',
              chunks: ['styles.css'],
              default: {
                file: 'index.js',
                manifest: `${
                  process.env.CVNA_APP_CDNSTATIC_BASE_URL
                }/softpull-modal-module/assets-manifest.json?v=${getMfeCacheBuster()}`
              }
            }
          ]
        ]
      ]
    });
  }, []);
}
